import firebase from './Firebase';

const remoteConfig = firebase.remoteConfig();

const minimumFetchIntervalMillis =
  process.env.NODE_ENV === 'production' ? 3600000 : 60;

remoteConfig.defaultConfig = {
  isFetching: false,
  isSusepValidated: false,
  error: null,
  config: {
    appOn: true,
    susepCheck: false,
    announcement: {
      show: false,
      url: ''
    }
  }
};

remoteConfig.settings = {
  fetchTimeoutMillis: 60000,
  minimumFetchIntervalMillis
};

export default remoteConfig;
